import React, { useState, useEffect } from 'react';
import { Input, Typography, Card, Row, Col, Divider } from 'antd';
import PostCard from '../../components/PostCard';
import { getAllPosts, searchPosts } from '../../api/localStorage';
import './index.css';

const { Search } = Input;
const { Title, Text } = Typography;

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchedPosts = searchTerm ? searchPosts(searchTerm) : getAllPosts();
    setPosts(fetchedPosts);
  }, [searchTerm]);

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const handlePostDeleted = (deletedId) => {
    setPosts(prevPosts => prevPosts.filter(post => post.id !== deletedId));
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '20px' }}>
      <Card 
        style={{ 
          marginBottom: 32, 
          textAlign: 'center', 
          borderRadius: 8, 
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)'
        }}
        bodyStyle={{ padding: '40px 24px' }}
      >
        <Title level={2} style={{ marginBottom: 12, color: '#1890ff' }}>欢迎来到我的博客</Title>
        <Text type="secondary" style={{ fontSize: '16px', display: 'block', marginBottom: 24 }}>
          分享技术与生活的点点滴滴
        </Text>
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          <Search
            placeholder="搜索文章标题或内容..."
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={handleSearch}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '100%', marginBottom: 8 }}
          />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            输入关键词搜索您感兴趣的文章
          </Text>
        </div>
      </Card>
      
      <div style={{ marginBottom: 24 }}>
        <Divider style={{ fontSize: '18px', margin: '16px 0' }}>
          <Text strong>最新文章</Text>
        </Divider>
      </div>
      
      {posts.length > 0 ? (
        <Row gutter={[24, 24]}>
          {posts.map(post => (
            <Col xs={24} sm={12} md={8} lg={6} key={post.id || Math.random()}>
              <PostCard post={post} onPostDeleted={handlePostDeleted} />
            </Col>
          ))}
        </Row>
      ) : (
        <Card 
          style={{ textAlign: 'center', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
          bodyStyle={{ padding: '40px 20px' }}
        >
          <div style={{ fontSize: 16, color: '#888' }}>
            <Text>没有找到相关文章</Text>
          </div>
        </Card>
      )}
    </div>
  );
};

export default Home;